import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { selectIsNewUser,selectIsSignedIn } from 'slices/authSlice'

function PublicRoute({ component, ...rest }) {
  const isNewUser = useSelector(selectIsNewUser)
  const isSignedIn=useSelector(selectIsSignedIn)
  const getPath = () => {
    if (isNewUser) {
      return "/"
    }
    else {
      return "/"
    }
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isSignedIn ? (
          <Redirect to={{
            pathname: getPath()
          }} />
        ) :
          (
            React.createElement(component, props)
          )
      }
    />
  )
}

export default PublicRoute
